var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierachyTwoTone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41490",
    "data-name": "Group 41490",
    transform: "translate(18951 -1985)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15747",
    "data-name": "Rectangle 15747",
    width: 16,
    height: 16,
    transform: "translate(-18951 1985)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hierachy_5_",
    "data-name": "hierachy (5)",
    d: "M21.372,26.862H20.31V24.728a.855.855,0,0,0-.854-.855H15.338V22.062h2.119a.676.676,0,0,0,.675-.675v-3.26a.676.676,0,0,0-.675-.675H12.542a.676.676,0,0,0-.675.675v3.26a.676.676,0,0,0,.675.675h2.118v1.811H10.544a.855.855,0,0,0-.854.855v2.134H8.628A.628.628,0,0,0,8,27.49v2.8a.628.628,0,0,0,.628.628h2.8a.628.628,0,0,0,.628-.628v-2.8a.628.628,0,0,0-.628-.628H10.367V24.728a.179.179,0,0,1,.177-.177h4.117v2.312H13.6a.628.628,0,0,0-.628.628v2.8a.628.628,0,0,0,.628.628h2.8a.628.628,0,0,0,.628-.628v-2.8a.628.628,0,0,0-.628-.628H15.338V24.55h4.118a.179.179,0,0,1,.177.177v2.134H18.571a.628.628,0,0,0-.628.628v2.8a.628.628,0,0,0,.628.628h2.8A.628.628,0,0,0,22,30.292v-2.8A.628.628,0,0,0,21.372,26.862Zm-9.994,3.38h-2.7v-2.7h2.7Zm4.972,0h-2.7v-2.7h2.7Zm4.972,0h-2.7v-2.7h2.7Z",
    transform: "translate(-18958 1968.814)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierachyTwoTone);
export default __webpack_public_path__ + "static/media/hierachy-two-tone.8da9514d668bd6141eaedaf6a5573052.svg";
export { ForwardRef as ReactComponent };